import { addHours, format, parse } from 'date-fns';

import { DATE_FORMAT, IMAGE_DATE_REGEX } from 'helper/products/synopticCharts';

/**
 * Converte a `date` de uma imagem sinótica ('YYYY-MM-DDTHH...') no rótulo de
 * data/hora da previsão ("dd.MM - HH'h'"), mesma regra do ForecastDaySlider desktop.
 */
export default function imageDateLabel(imageDate: string | undefined): string {
  if (!imageDate) return '';
  const match = imageDate.match(IMAGE_DATE_REGEX);
  if (!match) return '';

  const baseDate = parse(match[1], DATE_FORMAT, new Date());
  const offset = parseInt(match[2], 10);
  if (Number.isNaN(baseDate.getTime()) || Number.isNaN(offset)) return '';

  return format(addHours(baseDate, offset), "dd.MM - HH'h'");
}
